require('packs/commons/validation')

$(function () {
  if (isSessionStorageClear) {
    sessionStorage.removeItem('cardinfo');
  }

  $('#js-donation-form').validate({
    errorClass: 'c-form-error',
    rules: {
      'donation[donation_details_attributes][0][amount_other_for_select]': {
        required: '#donation_donation_details_attributes_0_amount_for_select_other:checked',
        min: 500
      },
      'donation[agreement]': {
        required: true
      }
    },
    messages: {
      'donation[donation_details_attributes][0][amount_other_for_select]': {
        required: 'その他金額を選択している場合、金額を入力してください',
        min: 'その他金額は500円以上で入力してください',
        number: 'その他金額は数字を入力してください'
      },
      'donation[agreement]': {
        required: 'プライバシーポリシーに同意してください'
      }
    }
  });

  $(document).on('change', '#donation_donation_details_attributes_0_amount_other_for_select', function () {
    $('#donation_donation_details_attributes_0_amount').val($(this).val());
  });

  $(document).on('change', 'input[name="donation[donation_details_attributes][0][amount_for_select]"]', function () {
    var value = $('input[name="donation[donation_details_attributes][0][amount_for_select]"]:checked').val();
    if (value !== 'other') {
      $('#donation_donation_details_attributes_0_amount_other_for_select').prop('disabled', true).val('');
      $('#donation_donation_details_attributes_0_amount').val(value);
      // その他金額以外の場合未入力を許可するのでエラー状態を解除
      $('#donation_donation_details_attributes_0_amount_other_for_select').removeClass('c-form-error');
      $('#donation_donation_details_attributes_0_amount_other_for_select-error').hide();
    } else {
      $('#donation_donation_details_attributes_0_amount_other_for_select').prop('disabled', false);
      $('#donation_donation_details_attributes_0_amount').val('');
      $('#donation_donation_details_attributes_0_amount_other_for_select').change();
    }
  });

  $(document).on('change', 'input[name="donation[user_kind]"]', function () {
    if ($('input[name="donation[user_kind]"]:checked').val() === 'individual') {
      $('.js-user-kind-individual-area input, .js-user-kind-individual-area select').prop('disabled', false);
      $('.js-user-kind-individual-area').show();
      $('.js-user-kind-corporate-area').hide();
      $('.js-user-kind-corporate-area input, .js-user-kind-corporate-area select').prop('disabled', true);
    } else {
      $('.js-user-kind-corporate-area input, .js-user-kind-corporate-area select').prop('disabled', false);
      $('.js-user-kind-corporate-area').show();
      $('.js-user-kind-individual-area').hide();
      $('.js-user-kind-individual-area input, .js-user-kind-individual-area select').prop('disabled', true);
    }
  });

  $(document).on('click', '#js-about-postings-modal-button', function () {
    $('#js-about-postings-modal').addClass('-opened');
  });

  $(document).on('click', '#js-about-postings-modal-backdrop,.js-close-modal-cancel-button', function () {
    $('#js-about-postings-modal').removeClass('-opened');
  });

  $('input[name="donation[donation_details_attributes][0][amount_for_select]"]:checked').change();
  $('input[name="donation[user_kind]"]').change();
});
